export enum PromotionPopupDelaySecondsType {
    FIVE_SECONDS = 5,
    FIVETEEN_SECONDS = 15,
    THIRTY_SECONDS = 30,
}